import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate(-1)}
      sx={{
        position: 'absolute',
        top: 24,
        left: { xs: 16, sm: 24 },
        color: '#0066b2',
        '&:hover': {
          backgroundColor: 'rgba(0, 102, 178, 0.08)',
        },
      }}
    >
      Back
    </Button>
  );
};

export default BackButton; 